export enum SizeEnum {
  xSmall = 'x-small',
  small = 'small',
  medium = 'medium',
  large = 'large',
  default = 'default'
}
